<template>
  <a-layout style="min-height: 100vh">
    <a-layout-sider
      v-model="collapsed"
      collapsible
      :width="240"
      class="sidebar"
    >
      <DashboardSidebarLogo :isSidebarOpened="!collapsed" />

      <DashboardSidebarNavigation :isSidebarOpened="!collapsed" />

      <DashboardSidebarFooter :isSidebarOpened="!collapsed" />
    </a-layout-sider>
    <a-layout style="overflow: &quot;auto&quot;; height: 100vh; background-color: #fff">
      <dashboard-alert-notification
        v-if="hasNotification"
        :notificationType="notification.type"
        :notificationButton="notification.button"
        :notificationText="notification.text"
      />
      <a-layout-header style="background: #fff; padding: 0; height: 72px">
        <DashboardHeader />
      </a-layout-header>
      <a-layout-content style="padding: 24px; background: #fff">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import DashboardAlertNotification from "./DashboardAlertNotification.vue"
import DashboardHeader from "./DashboardHeader.vue"
import DashboardSidebarFooter from "./DashboardSidebarFooter.vue"
import DashboardSidebarLogo from "./DashboardSidebarLogo.vue"
import DashboardSidebarNavigation from "./DashboardSidebarNavigation.vue"

const windowWidth = window.innerWidth

export default {
  name: "Dashboard",
  components: {
    DashboardAlertNotification,
    DashboardSidebarFooter,
    DashboardSidebarNavigation,
    DashboardSidebarLogo,
    DashboardHeader
  },
  props: {
    hasNotification: {
      type: Boolean,
      required: true
    },
    notification: {
      type: Object
    }
  },
  data() {
    return {
      collapsed: windowWidth <= 1366 || window.localStorage.getItem("collapse-menu") === "true"
    }
  },
  watch: {
    collapsed(value) {
      window.localStorage.setItem("collapse-menu", JSON.stringify(value))
    }
  }
}
</script>

<style lang="scss">
.sidebar {
  height: 100vh;
  position: fixed;

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }
}

// .dashboard-wrapper {
//   display: flex;
//   flex-direction: column;
// }

// .dashboard {
//   $root: &;

//   line-height: $base-line-height;
//   font-size: $base-font-size;
//   position: relative;
//   display: flex;

//   &__sidebar {
//     width: $sider-width-opened;

//     @include transition(width, $transition-duration-fast);

//     &--closed {
//       width: $sider-width-collapsed;
//     }
//   }

//   &__container {
//     will-change: width;
//     overflow-x: hidden;
//     flex: 1;
//     width: 100%;
//     min-height: 100vh;
//     height: 100vh;
//     display: flex;
//     flex-direction: column;
//     overflow-y: auto;

//     &--with-alert {
//       min-height: calc(100vh - #{$dashboard-alert-height});
//       height: calc(100vh - #{$dashboard-alert-height});
//     }
//   }

//   &__view {
//     padding: 24px;
//   }
// }
</style>
